module.exports = __webpack_public_path__ + "static/img/banner.a0502e8.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner.jpeg
// module id = m1Fl
// module chunks = 1